import React from "react";
import PendingApprovalsMainComponent from "../components/PendingApprovals/PendingApprovalsMainComponent";

const PendingApprovalsPage = () => {
  return <PendingApprovalsMainComponent />;
};

export default PendingApprovalsPage;